import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SeparatorServices } from "../../../../services/separators";

/**
 * Generated class for the MenuPageCustomizeSeparatorsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-carta-page-customize-separators',
    templateUrl: 'carta-page-customize-separators.html',
})
export class CartaPageCustomizeSeparatorsPage {
    menu_uid: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public separatorServices: SeparatorServices) {
        this.menu_uid = this.navParams.get('menu_uid');
    }

}



// WEBPACK FOOTER //
// ./src/pages/carta/carta-view/carta-partial-customize-options/carta-page-customize-separators/carta-page-customize-separators.ts